import bulkImportReducer from './reducers';

export default bulkImportReducer;
